package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class CompetenceCriterionQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    competence_id: String,
    label: String,
    description: String?,
    level: Long,
    evaluated_at: Long?,
    evaluation_note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-180_813_077, arrayOf("competence_criterion"), driver,
      "CompetenceCriterion.sq", "selectAll",
      "SELECT competence_criterion.id, competence_criterion.competence_id, competence_criterion.label, competence_criterion.description, competence_criterion.level, competence_criterion.evaluated_at, competence_criterion.evaluation_note, competence_criterion.order_index, competence_criterion.created_at, competence_criterion.updated_at, competence_criterion.is_deleted, competence_criterion.deleted_at, competence_criterion.synced_at FROM competence_criterion WHERE is_deleted = 0 ORDER BY competence_id, order_index") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectAll(): Query<Competence_criterion> = selectAll { id, competence_id, label,
      description, level, evaluated_at, evaluation_note, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Competence_criterion(
      id,
      competence_id,
      label,
      description,
      level,
      evaluated_at,
      evaluation_note,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    competence_id: String,
    label: String,
    description: String?,
    level: Long,
    evaluated_at: Long?,
    evaluation_note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectById(id: String): Query<Competence_criterion> = selectById(id) { id_,
      competence_id, label, description, level, evaluated_at, evaluation_note, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Competence_criterion(
      id_,
      competence_id,
      label,
      description,
      level,
      evaluated_at,
      evaluation_note,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByCompetence(competence_id: String, mapper: (
    id: String,
    competence_id: String,
    label: String,
    description: String?,
    level: Long,
    evaluated_at: Long?,
    evaluation_note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByCompetenceQuery(competence_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectByCompetence(competence_id: String): Query<Competence_criterion> =
      selectByCompetence(competence_id) { id, competence_id_, label, description, level,
      evaluated_at, evaluation_note, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Competence_criterion(
      id,
      competence_id_,
      label,
      description,
      level,
      evaluated_at,
      evaluation_note,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    competence_id: String,
    label: String,
    description: String?,
    level: Long,
    evaluated_at: Long?,
    evaluation_note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_959_984_484, arrayOf("competence_criterion"), driver,
      "CompetenceCriterion.sq", "selectDirty",
      "SELECT competence_criterion.id, competence_criterion.competence_id, competence_criterion.label, competence_criterion.description, competence_criterion.level, competence_criterion.evaluated_at, competence_criterion.evaluation_note, competence_criterion.order_index, competence_criterion.created_at, competence_criterion.updated_at, competence_criterion.is_deleted, competence_criterion.deleted_at, competence_criterion.synced_at FROM competence_criterion WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectDirty(): Query<Competence_criterion> = selectDirty { id, competence_id, label,
      description, level, evaluated_at, evaluation_note, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Competence_criterion(
      id,
      competence_id,
      label,
      description,
      level,
      evaluated_at,
      evaluation_note,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    competence_id: String,
    label: String,
    description: String?,
    level: Long,
    evaluated_at: Long?,
    evaluation_note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Competence_criterion> = selectByIdAnyState(id) {
      id_, competence_id, label, description, level, evaluated_at, evaluation_note, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Competence_criterion(
      id_,
      competence_id,
      label,
      description,
      level,
      evaluated_at,
      evaluation_note,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    competence_id: String,
    label: String,
    description: String?,
    level: Long,
    evaluated_at: Long?,
    evaluation_note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(111_482_003, """
        |INSERT INTO competence_criterion(id, competence_id, label, description, level, evaluated_at, evaluation_note, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 10) {
          bindString(0, id)
          bindString(1, competence_id)
          bindString(2, label)
          bindString(3, description)
          bindLong(4, level)
          bindLong(5, evaluated_at)
          bindString(6, evaluation_note)
          bindLong(7, order_index)
          bindLong(8, created_at)
          bindLong(9, updated_at)
        }
    notifyQueries(111_482_003) { emit ->
      emit("competence_criterion")
    }
  }

  public fun update(
    competence_id: String,
    label: String,
    description: String?,
    level: Long,
    evaluated_at: Long?,
    evaluation_note: String?,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(456_428_195, """
        |UPDATE competence_criterion
        |SET competence_id = ?, label = ?, description = ?, level = ?, evaluated_at = ?, evaluation_note = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 9) {
          bindString(0, competence_id)
          bindString(1, label)
          bindString(2, description)
          bindLong(3, level)
          bindLong(4, evaluated_at)
          bindString(5, evaluation_note)
          bindLong(6, order_index)
          bindLong(7, updated_at)
          bindString(8, id)
        }
    notifyQueries(456_428_195) { emit ->
      emit("competence_criterion")
    }
  }

  public fun setLevel(
    level: Long,
    evaluated_at: Long?,
    evaluation_note: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(615_817_116,
        """UPDATE competence_criterion SET level = ?, evaluated_at = ?, evaluation_note = ?, updated_at = ? WHERE id = ?""",
        5) {
          bindLong(0, level)
          bindLong(1, evaluated_at)
          bindString(2, evaluation_note)
          bindLong(3, updated_at)
          bindString(4, id)
        }
    notifyQueries(615_817_116) { emit ->
      emit("competence_criterion")
    }
  }

  public fun reorder(
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_702_409_631,
        """UPDATE competence_criterion SET order_index = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, order_index)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_702_409_631) { emit ->
      emit("competence_criterion")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-249_302_193,
        """UPDATE competence_criterion SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-249_302_193) { emit ->
      emit("competence_criterion")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-1_698_645_004,
        """UPDATE competence_criterion SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-1_698_645_004) { emit ->
      emit("competence_criterion")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(953_591_425,
        """UPDATE competence_criterion SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(953_591_425) { emit ->
      emit("competence_criterion")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("competence_criterion", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("competence_criterion", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_310_196_792,
        """SELECT competence_criterion.id, competence_criterion.competence_id, competence_criterion.label, competence_criterion.description, competence_criterion.level, competence_criterion.evaluated_at, competence_criterion.evaluation_note, competence_criterion.order_index, competence_criterion.created_at, competence_criterion.updated_at, competence_criterion.is_deleted, competence_criterion.deleted_at, competence_criterion.synced_at FROM competence_criterion WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "CompetenceCriterion.sq:selectById"
  }

  private inner class SelectByCompetenceQuery<out T : Any>(
    public val competence_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("competence_criterion", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("competence_criterion", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-2_131_654_282,
        """SELECT competence_criterion.id, competence_criterion.competence_id, competence_criterion.label, competence_criterion.description, competence_criterion.level, competence_criterion.evaluated_at, competence_criterion.evaluation_note, competence_criterion.order_index, competence_criterion.created_at, competence_criterion.updated_at, competence_criterion.is_deleted, competence_criterion.deleted_at, competence_criterion.synced_at FROM competence_criterion WHERE competence_id = ? AND is_deleted = 0 ORDER BY order_index""",
        mapper, 1) {
      bindString(0, competence_id)
    }

    override fun toString(): String = "CompetenceCriterion.sq:selectByCompetence"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("competence_criterion", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("competence_criterion", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_215_314_451,
        """SELECT competence_criterion.id, competence_criterion.competence_id, competence_criterion.label, competence_criterion.description, competence_criterion.level, competence_criterion.evaluated_at, competence_criterion.evaluation_note, competence_criterion.order_index, competence_criterion.created_at, competence_criterion.updated_at, competence_criterion.is_deleted, competence_criterion.deleted_at, competence_criterion.synced_at FROM competence_criterion WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "CompetenceCriterion.sq:selectByIdAnyState"
  }
}
